import translate from './applyTranslation';
const server =true? window.location.origin : 'https://staging.cheap.cust.commerz.se';
const APICall = async (params) => {
  let { verb, url, body, access_token } = params;
  var myHeaders = new Headers();
  if (access_token) {
    myHeaders.append("Authorization", `Bearer ${access_token}`);
  }
  var requestOptions = {
    method: verb || 'get',
    headers: myHeaders,
    body: body,
  };

  let requestURL = `${server}/api/${url}`
  return await fetch(requestURL, requestOptions)
    .then(async response => {
      let handledResponse = await response.json();
      if (response.status < 400) {
        return handledResponse;
      } else {
        let err = {
          error: handledResponse.message || handledResponse.error || response.statusText,
          err: JSON.stringify(handledResponse),
        }
        throw err;
      }
    })
    .then(res => {
      if (res.error) {
        throw (res);
      }
      return res;
    })
    .catch(error => {
      let err = {
        error: error.error || translate('', 'generic_api_call_error'),
        err: JSON.stringify(error),
      }
      throw err;
    });
}
export const APIDownload = async (params) => {
  let { verb, url, body, access_token } = params;
  const myHeaders = new Headers();
  if (access_token) {
    myHeaders.append("Authorization", `Bearer ${access_token}`);
  }

  const requestOptions = {
    method: verb || 'get',
    headers: myHeaders,
    body: body,
    redirect: 'follow'
  };

  const requestURL = `${server}/api/${url}`;
  const response = await fetch(requestURL, requestOptions);

  const blob = await response.blob();
  if (response.status >= 400) {
    // eslint-disable-next-line no-throw-literal
    throw {
      error: response.statusText,
      err: await blob.text()
    };
  }

  // Try to extract filename from Content-Dispositio
  const contentDisposition = response.headers.get("Content-Disposition");
  let filename = "download";
  if (contentDisposition && contentDisposition.includes("filename=")) {
    filename = contentDisposition
      .split("filename=")[1]
      .split(";")[0]
      .replace(/['"]/g, ""); // remove quotes if present
  }

  return { blob, filename };
};

export default APICall;

